import {inject, injectable} from "inversify";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import chance from "@/modules/base/services/chance";
import {YouthPlayer} from "@/modules/youth/entity";

@injectable()
export default class YouthPlayerWageCalculator {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  calculate(player: YouthPlayer): number {
    return chance.integer({min: 1, max: 5}) * 10;
  }
}
